import OSS from 'ali-oss'
import axios from './interceptors'

const constants = ({
  image: {original: '', key: '@key', avatar: '@avatar', poster: '@poster'},
  video: {original: '', p720: '@720p'},
  size: {original: 'original', large: 'large', medium: 'medium', small: 'small', mini: 'mini'}
})
const parameter = {
  endpoint: 'oss-cn-shenzhen.aliyuncs.com',
  region: 'oss-cn-shenzhen',
  bucket: 'miaotu-media',
  accessKeyId: '',
  accessKeySecret: '',
  stsToken: '',
  timeout: '600000'
}
// const parameter = {
//   endpoint: 'oss-cn-shenzhen.aliyuncs.com',
//   region: 'oss-cn-shenzhen',
//   bucket: 'miaotu-dev',
//   accessKeyId: '',
//   accessKeySecret: '',
//   stsToken: '',
//   timeout: '600000'
// }

function pad2 (n) {
  return n < 10 ? '0' + n : n
}

export default {
  constants,
  generatePathName: function (pathname) {
    if (pathname != null && pathname !== '') {
      return pathname
    }
    let date = new Date()
    return date.getFullYear().toString() + pad2(date.getMonth() + 1) + pad2(date.getDate()) + pad2(date.getHours()) + pad2(date.getMinutes()) + pad2(date.getSeconds())
  },
  buildTempPath: function (pathname) {
    return 'temp/' + pathname + '/'
  },
  auth: async function () {
    let res = await axios.post('https://rest.saobaar.com/file/auth/token')
    parameter.stsToken = res.data.securityToken
    parameter.accessKeyId = res.data.accessKeyId
    parameter.accessKeySecret = res.data.accessKeySecret
  },
  multipartUpload: function (name, file, options = {}) {
    return new OSS(parameter).multipartUpload(name, file, options)
  },
  generateURL: function (objName) {
    try {
      return new OSS(parameter).signatureUrl(objName)
    } catch (e) {
      return ''
    }
  },
  generateTempURL: async function (pathname, size) {
    try {
      let objName = 'temp/' + pathname + '/image.jpg'
      switch (size) {
        case constants.size.original:
          return await new OSS(parameter).signatureUrl(objName)
        case constants.size.large:
          return await new OSS(parameter).signatureUrl(objName, {'process': 'image/resize,m_lfit,w_1024,h_1024'})
        case constants.size.medium:
          return await new OSS(parameter).signatureUrl(objName, {'process': 'image/resize,m_lfit,w_512,h_512'})
        case constants.size.small:
          return await new OSS(parameter).signatureUrl(objName, {'process': 'image/resize,m_lfit,w_128,h_128'})
        case constants.size.mini:
          return await new OSS(parameter).signatureUrl(objName, {'process': 'image/resize,m_lfit,w_64,h_64'})
        default:
          return await new OSS(parameter).signatureUrl(objName, {'process': 'image/resize,m_lfit,w_512,h_512'})
      }
    } catch (e) {
      return ''
    }
  },
  generateImageURL: async function (pathname, objname, size) {
    try {
      let objName = 'final/' + pathname + '/image' + objname + '.jpg'
      switch (size) {
        case constants.size.original:
          return await new OSS(parameter).signatureUrl(objName)
        case constants.size.large:
          return await new OSS(parameter).signatureUrl(objName, {'process': 'image/resize,m_lfit,w_1024,h_1024'})
        case constants.size.medium:
          return await new OSS(parameter).signatureUrl(objName, {'process': 'image/resize,m_lfit,w_512,h_512'})
        case constants.size.small:
          return await new OSS(parameter).signatureUrl(objName, {'process': 'image/resize,m_lfit,w_128,h_128'})
        case constants.size.mini:
          return await new OSS(parameter).signatureUrl(objName, {'process': 'image/resize,m_lfit,w_64,h_64'})
        default:
          return await new OSS(parameter).signatureUrl(objName, {'process': 'image/resize,m_lfit,w_512,h_512'})
      }
    } catch (e) {
      return ''
    }
  },
  generateVideoURL: async function (pathname, objname) {
    try {
      let objName = 'final/' + pathname + '/video' + objname + '.mp4'
      return await new OSS(parameter).signatureUrl(objName)
    } catch (e) {
      return ''
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/oss.js